import { makeTable } from "../utils/tables";

export const origins = makeTable("origins", [
  {
    name: "CARBON",
    description:
      "Grown in space-based exowombs. Short life spans. Live their lives offworld and are untroubled by the darkness of space. More comfortable in an EVA suit than out of one.",
    benefits: makeTable("originBenefits", [
      {
        name: "ENGINEERED LUNGS",
        description:
          "Use half oxygen compared to everyone else (one step for every two normal steps).",
      },
      {
        name: "GEARHEAD",
        description: "Repair twice as fast.",
      },
    ]),
  },
  {
    name: "CHROME",
    description:
      "Ancient AI placed in a body vessel of organic material. Part machine, but with an organic CPU and a distributed neural system that requires oxygen.",
    benefits: makeTable("originBenefits", [
      {
        name: "NATIVE MACHINE",
        description:
          "You can converse with computers as if they were real people. Plug in and find a friend.",
      },
      {
        name: "BODY BATTERY",
        description:
          "You can use your body to power one small electrical device, such as a hand-held item.",
      },
    ]),
  },
  {
    name: "PUNK",
    description:
      "Rebellious and nonconformist with a long history. They have seen civilizations collapse, and others turn against each other.",
    benefits: makeTable("originBenefits", [
      {
        name: "STUBBORN",
        description:
          "You never give up. Reroll any dice roll once per session.",
      },
      {
        name: "GREEN THUMB",
        description:
          "You know everything about plants and what to use them for. You start with a pocket greenhouse and some random seeds.",
      },
    ]),
  },
  {
    name: "SOLPOD",
    description:
      "Hibernating for decades, only staying awake for short periods. They dedicate their lives to the scientific study of slow, cosmic phenomena.",
    benefits: makeTable("originBenefits", [
      {
        name: "LONG-LIVED",
        description: "You have an old and useful contact in every port.",
      },
      {
        name: "OLD TECH",
        description:
          "You have a portable hibernation pod. Regenerates lost limbs, prevents aging and the need to eat. Powered by starlight.",
      },
    ]),
  },
  {
    name: "VELOCITY CURSED",
    description:
      "Ill-fated ones that have started to lose their connection to reality. They shift and flicker in and out of spacetime with glitching faces.",
    benefits: makeTable("originBenefits", [
      {
        name: "FUTURE MEMORY",
        description:
          "You have already been here. Once per session, ask the referee for directions.",
      },
      {
        name: "POCKET WORLD",
        description:
          "You start with a portable non-phys server, housing a virtual reality where you store memories to connect the past and future of your life. Up to ten users can connect simultaneously.",
      },
    ]),
  },
  {
    name: "VOID",
    description:
      "Robed nihility shamans, hidden behind masks, speaking through synthetic voice scramblers. They have seen visions of the edge of the universe.",
    benefits: makeTable("originBenefits", [
      {
        name: "VOICE OF THE VOID",
        description:
          "You can make nearby electronics emit static and crackling whispers.",
      },
      {
        name: "MASKED",
        description:
          "You have a mask that you can reshape during rest into the resemblance of another face or mask. At a distance, it fools most.",
      },
    ]),
  },
]);
